import { Component, OnInit } from '@angular/core';
import { AbstractFormWidgetComponent } from '../../../../../../shared/components/widget/abstract-form-widget/abstract-form-widget.component';
import { ResourceService } from 'sce-core';
import { NavigationService } from '../../../../../../core/navigation.service';
import { LeftPanelService } from '../../../../../../layout/home/services/left-panel.service';
import { AlertService } from 'sce-core';
import { UserService } from '../../../../../../core/security/user.service';
import { DatePickerConfigService } from '../../../../../../shared/components/datepicker/datepicker-config.service';
import { TransferDataEditorService } from '../../services/transfer-data-editor.service';
import { TransferDataService } from '../../services/transfer-data.service';
import { LookupInputComponent } from '../../../../../../shared/components/lookup-input/lookup-input.component';

@Component({
  selector: 'lfwms-transfer-primary-accordion',
  templateUrl: './transfer-primary-accordian.component.html',
  styleUrls: ['./transfer-primary-accordian.component.css']
})
export class TransferPrimaryAccordianComponent extends AbstractFormWidgetComponent implements OnInit {
  public dataEditor: TransferDataEditorService;
  public dataService: TransferDataService;

  constructor(protected resourceService: ResourceService,
    protected navService: NavigationService,
    protected leftPanelService: LeftPanelService,
    protected alertService: AlertService,
    protected userService: UserService,
    protected dateConfigService: DatePickerConfigService) {
    super(resourceService, navService, leftPanelService, alertService, userService, dateConfigService);
  }

  public setPrimeFocus(row: any, property: any) {
      this.keyEventHandler.setFocusedCell(row, property);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/inventory/vas/transfer/transfer-home/transfer-primary-accordian/transfer-primary-accordian.component.ts